// Lightweight iOS-style alert modal (title + message + OK).
export default function InfoAlert({ alert, onClose }) {
  if (!alert) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-8">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative w-full max-w-xs rounded-2xl bg-white p-5 text-center shadow-xl">
        <h3 className="text-base font-bold text-gray-900">{alert.title}</h3>
        {alert.message && (
          <p className="mt-1.5 text-sm text-gray-500">{alert.message}</p>
        )}
        <button
          onClick={onClose}
          className="mt-4 w-full rounded-xl bg-[#FF6B35] py-2.5 text-sm font-bold text-white active:scale-[0.98]"
        >
          OK
        </button>
      </div>
    </div>
  );
}
